import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import api from "../../../api/api";
import { Link } from "react-router-dom";

const AssignEmployeeModal = ({
  assignEmployeeModalOpen,
  setAssignEmployeeModalOpen,
  selectedDay,
  handleAssignSubmit,
}) => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const [assignmentDetails, setAssignmentDetails] = useState({
    employee: selected,
    date: new Date().toISOString().split("T")[0],
    shiftStart: "09:45",
    shiftEnd: "18:00",
    breakTime: 30,
  });

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const response = await api.get("/employee/byBusiness");

      const employeeList = response.data.listOfEmployees || [];
      setEmployees(employeeList);

      if (employeeList.length > 0) {
        setSelected(employeeList[0]);
        setAssignmentDetails((values) => ({
          ...values,
          employee: employeeList[0],
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    setAssignmentDetails((values) => ({ ...values, employee: selected }));
  }, [selected]);

  useEffect(() => {
    setAssignmentDetails((values) => ({ ...values, date: selectedDay?.date }));
  }, [selectedDay]);

  const handleChange = (e) => {
    setAssignmentDetails((values) => ({
      ...values,
      [e.target.name]: e.target.value,
    }));
  };

  // const handleSubmit = async () => {
  //     try{
  //         const date = new Date(assignmentDetails.date);
  //         const [startHours, startMinutes] = assignmentDetails.startTime.split(':');
  //         const [endHours, endMinutes] = assignmentDetails.endTime.split(':');

  //         const shiftStart = new Date(date);
  //         shiftStart.setHours(parseInt(startHours), parseInt(startMinutes), 0, 0);

  //         const shiftEnd = new Date(date);
  //         shiftEnd.setHours(parseInt(endHours), parseInt(endMinutes), 0, 0);

  //         if (shiftEnd < shiftStart) {
  //             shiftEnd.setDate(shiftEnd.getDate() + 1);
  //         }

  //         const rosterData = {
  //             employeeId: selected._id,
  //             date: date.toISOString(),
  //             shiftStart: shiftStart.toISOString(),
  //             shiftEnd: shiftEnd.toISOString(),
  //             breakTime: parseInt(assignmentDetails.breakTime) || 0
  //         };

  //         await api.post('/roster/', rosterData);

  //     }catch(err){
  //         console.log(err)
  //     }

  //     setAssignEmployeeModalOpen(false)
  // }

  return (
    <Dialog
      open={assignEmployeeModalOpen}
      onClose={setAssignEmployeeModalOpen}
      className="relative z-10"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="w-full relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={() => setAssignEmployeeModalOpen(false)}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            {employees.length > 0 ? (
              <>
                <div>
                  <div className="sm:mt-0">
                    <DialogTitle
                      as="h3"
                      className="text-center font-semibold text-gray-900"
                    >
                      Assign employee
                    </DialogTitle>
                    <div className="mt-2">
                      <form className="space-y-6">
                        <div>
                          {/* <label for="employee" className="block text-sm/6 font-medium text-gray-900">Employee</label>
                                    <div class="mt-2">
                                        <input id="employee" name="employee" type="text" required className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"/>
                                    </div> */}
                          <Listbox value={selected} onChange={setSelected}>
                            <Label className="block text-sm/6 font-medium text-gray-900">
                              Assign to
                            </Label>
                            <div className="relative mt-2">
                              <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm/6">
                                <span className="block truncate">
                                  {selected?.firstName} {selected?.lastName}
                                </span>
                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                  <ChevronUpDownIcon
                                    aria-hidden="true"
                                    className="size-5 text-gray-400"
                                  />
                                </span>
                              </ListboxButton>

                              <ListboxOptions
                                transition
                                className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                              >
                                {employees.map((employee) => (
                                  <ListboxOption
                                    key={employee._id}
                                    value={employee}
                                    className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
                                  >
                                    <span className="block truncate font-normal group-data-[selected]:font-semibold">
                                      {employee.firstName} {employee.lastName}
                                    </span>

                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                      <CheckIcon
                                        aria-hidden="true"
                                        className="size-5"
                                      />
                                    </span>
                                  </ListboxOption>
                                ))}
                              </ListboxOptions>
                            </div>
                          </Listbox>
                        </div>
                        <div>
                          <label
                            htmlFor="date"
                            className="block text-sm/6 font-medium text-gray-900"
                          >
                            Date
                          </label>
                          <div className="mt-2">
                            <input
                              onChange={handleChange}
                              defaultValue={assignmentDetails.date}
                              id="date"
                              name="date"
                              type="date"
                              required
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="shiftStart"
                            className="block text-sm/6 font-medium text-gray-900"
                          >
                            Start time
                          </label>
                          <div className="mt-2">
                            <input
                              onChange={handleChange}
                              id="shiftStart"
                              name="shiftStart"
                              type="time"
                              defaultValue={assignmentDetails.shiftStart}
                              required
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="shiftEnd"
                            className="block text-sm/6 font-medium text-gray-900"
                          >
                            End time
                          </label>
                          <div className="mt-2">
                            <input
                              onChange={handleChange}
                              id="shiftEnd"
                              name="shiftEnd"
                              type="time"
                              defaultValue={assignmentDetails.shiftEnd}
                              required
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="breakTime"
                            className="block text-sm/6 font-medium text-gray-900"
                          >
                            Break (minutes)
                          </label>
                          <div className="mt-2">
                            <input
                              onChange={handleChange}
                              id="breakTime"
                              name="breakTime"
                              type="number"
                              defaultValue={assignmentDetails.breakTime}
                              min="0"
                              step={15}
                              required
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="mt-6 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    onClick={() => handleAssignSubmit(assignmentDetails)}
                    className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto"
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    onClick={() => setAssignEmployeeModalOpen(false)}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Cancel
                  </button>
                </div>
              </>
            ) : (
              <div>
                <p
                  className="pt-10 text-center text-sm text-gray-500"
                >
                  You don't have any employees! Go to your{" "}
                  <Link
                    to={`/manage-employees`}
                    className="font-medium text-indigo-600"
                  >
                    manage employees
                  </Link>
                </p>
              </div>
            )}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default AssignEmployeeModal;
